import { Button, DialogContent, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import { noop } from 'utils';
import { isHipaaLink } from '../../../config/productProfile';

import styles from './SubscriptionRequiredDialog.module.scss';

export interface SubscriptionRequiredDialogProps extends DialogProps {
  isProvider: boolean;
  isCancelled?: boolean;
  organization?: string;
  onConfirm: () => void;
}

export function SubscriptionRequiredDialog({
  onConfirm,
  isProvider,
  isCancelled = false,
  organization,
  ...rest
}: SubscriptionRequiredDialogProps) {
  const { t } = useTranslation('auth');

  return (
    <Dialog {...rest} className={styles.dialog} onClose={noop}>
      <DialogContent>
        <Typography component='h4' variant='h4' color='#FF3D3D'>
          {isProvider || isCancelled
            ? t('subscriptionRequiredDialog.requiredTitle')
            : t('subscriptionRequiredDialog.expiredTitle')}
        </Typography>

        <Typography component='p' variant='body2'>
          {isProvider
            ? organization
              ? t('subscriptionRequiredDialog.providerBodyWithOrganization', { organization })
              : t('subscriptionRequiredDialog.providerBodyWithoutOrganization')
            : t('subscriptionRequiredDialog.upgradeBody', { brand: isHipaaLink ? 'HIPAA LINK' : 'VIA3' })}
        </Typography>

        <Button variant='contained' onClick={onConfirm} className={styles.formButton}>
          {t('subscriptionRequiredDialog.ok')}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
